<app-dpr-activities-grid
  [dprDetails]="dprDetails$ | async"
  [selectedSubproject]="selectedSubproject$ | async"
  [activityStream]="activityStream$ | async"
  [gridData]="gridData$ | async"
  [canEdit]="canEdit"
  [isAppOnline]="isAppOnline$ | async"
  [availableDates]="availableDates$ | async"
  [userPreferences]="userPreferences$ | async"
  [isHandset]="screenSizeService.isHandset$ | async"
  (gridRegistered)="onGridRegistered($event)"
  (copyActivities)="onSelectedActivitiesCopied($event)"
  (reactivateParentContainer)="activateComponent()"
></app-dpr-activities-grid>
